export default {
  homePage:{
    home:'首页',
    factory:'我是铸造厂',
    supplier:'我是供应商',
    login:'登录',
    logout:'退出',
    signUp:'注册',
  },
  
}
